import type { ThirdPartyPlugin } from '../types';
import { promisifyLoad } from '../utils';
import { setup, load } from './script';
import type { UserLeapWindow } from './types';
import type { CurrentUser } from '~/types';

const appId = process.env.isProduction ? 'LVmZWcgU6n' : '_k5WJJvDL';

declare global {
  interface Window {
    /**
     * Userleap plugin
     * @see [docs](https://docs.sprig.com/docs/web-javascript)
     */
    UserLeap: UserLeapWindow;
  }
}

function setUser(user: CurrentUser) {
  if (!user && window.UserLeap?.userId) {
    return window.UserLeap.logoutUser();
  }

  if (user && window.UserLeap) {
    window.UserLeap('setUserId', user.id);
    window.UserLeap('setEmail', user.email);
    window.UserLeap('setAttribute', 'is_user', true);
  }
}

/**
 * @description Currently, the script seems to cause performance issues when loaded in all pages.
 * Load only when it's needed.
 */
const userLeapPlugin: ThirdPartyPlugin = ({ app: { store } }) => {
  setup(appId);

  return {
    entry: window.UserLeap,
    load: () => {
      store?.watch(store => store.auth.user, setUser, { immediate: true });
      return promisifyLoad(load, appId)();
    },
  };
};

export default userLeapPlugin;
